import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  fields: {
    marginBottom: theme.spacing(3),
    width: 'calc(100% + 24px)',

    '& > .input-container': {
      paddingTop: 0,
      paddingBottom: 0,

      [theme.breakpoints.up('md')]: {
        minWidth: '280px',
        maxWidth: '408px',
        flexGrow: 1,
      },
    },

    '& .MuiFormControl-root': {
      padding: 0,
    },
  },
  fieldsUniversal: {
    marginBottom: theme.spacing(3),

    '& > .input-container': {
      paddingTop: 0,
      paddingBottom: 0,
    },

    '& .MuiFormControl-root': {
      padding: 0,
    },
  },
  button: {
    display: 'block',
    width: '100%',
    maxWidth: '327px',
    margin: `0 auto ${theme.spacing(3)}px`,

    [theme.breakpoints.up('md')]: {
      marginLeft: 0,
      marginRight: 0,
    },
  },
  buttonUniversal: {
    display: 'block',
    width: '100%',
    marginBottom: theme.spacing(2),

    [theme.breakpoints.up('sm')]: {
      maxWidth: '300px',
    },
  },
}));
